import type { ReactElement } from 'react';
import { ErrorCode } from '@gr/core/errors';
import { META_STATUSES } from '@gr/core/content/posts/meta-status';
import { useT } from '../../../../app/di';
import { Button } from '../../../../ui-kit/Button/Button';
import { FieldRow, FieldRowActions, FieldRowGrow } from '../../../../ui-kit/FieldRow/FieldRow';
import { FormAlert, FormSelectField, FormTextField, useServerForm } from '../../../../ui-kit/form/form';
import type { ServerOutcome } from '../../../../ui-kit/form/server-errors';
import { NEW_STATUS, normalizedStatus, STATUS_FORM_FIELDS, type StatusValues } from '../model/status-form';

/** POST-UC-9: добавить статус; после добавления название очищается, цвет и метастатус остаются. */
export function NewStatusForm({ onSubmit }: { onSubmit(values: StatusValues): Promise<ServerOutcome> }): ReactElement {
  const { t } = useT();
  const { form, submit } = useServerForm<StatusValues>({
    defaultValues: NEW_STATUS,
    fields: STATUS_FORM_FIELDS,
    onSubmit: (values) => onSubmit(normalizedStatus(values)),
    afterSuccess: (values) => ({ ...values, name: '' }),
  });
  const { control, formState } = form;
  return (
    <form className="u-stack" onSubmit={submit} noValidate>
      <FormAlert form={form} />
      <FieldRow>
        <FieldRowGrow>
          <FormTextField control={control} name="name" label={t('posts.statuses.name')} rules={{ required: ErrorCode.FieldRequired }} disabled={formState.isSubmitting} />
        </FieldRowGrow>
        <FormTextField control={control} name="color" label={t('posts.statuses.color')} type="color" disabled={formState.isSubmitting} />
        <FormSelectField control={control} name="meta" label={t('posts.statuses.meta')} options={META_STATUSES.map((meta) => ({ value: meta, label: t(`posts.meta.${meta}`) }))} disabled={formState.isSubmitting} />
        <FieldRowActions>
          <Button type="submit" variant="primary" icon="plus" loading={formState.isSubmitting}>
            {t('posts.statuses.add')}
          </Button>
        </FieldRowActions>
      </FieldRow>
    </form>
  );
}
